import { render } from "./SliderTableInput.vue?vue&type=template&id=72662486&scoped=true"
import script from "./SliderTableInput.vue?vue&type=script&lang=js"
export * from "./SliderTableInput.vue?vue&type=script&lang=js"

import "./SliderTableInput.vue?vue&type=style&index=0&id=72662486&scoped=true&lang=css"

import exportComponent from "/Users/sahanakumari/Documents/GitHub/zsurvey-app/zsurvey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72662486"]])

export default __exports__